import React from "react";
import {Box, IconButton, Tab, Tabs, Tooltip} from "@mui/material";
import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import {WORKSPACE_THEME} from "../../elevationTool/menubar/MenuBar";
import {SidebarTab, sidebarTabLabel, sidebarTabWorkspace} from "./useSidebarElevationApp";

const TABS: SidebarTab[] = ["screen", "door", "hardware", "anchors"];

const TABS_SX = {
    minHeight: 32,
    flex: 1,
    "& .MuiTab-root": {minHeight: 32, py: 0, px: 1.5, minWidth: 0, fontSize: 12, color: "rgba(255,255,255,0.7)"},
    "& .Mui-selected": {color: "#fff !important"},
    "& .MuiTabs-indicator": {backgroundColor: "#fff"},
    "& .Mui-disabled": {color: "rgba(255,255,255,0.3) !important"},
};

// the sidebar's ribbon: a tab per elevation (plus anchors) in the workspace's colour, and the
// collapse button.
export function ElevationSidebarHeader(props: {
    tab: SidebarTab;
    onTabChange(tab: SidebarTab): void;
    onCollapse(): void;
    // anchors live on a drw screen elevation only.
    anchorsDisabled: boolean;
}) {
    const bg = WORKSPACE_THEME[sidebarTabWorkspace(props.tab)];

    return (
        <Box sx={{display: "flex", alignItems: "center", bgcolor: bg, color: "#fff", flexShrink: 0}}>
            <Tabs value={props.tab} onChange={(e, value: SidebarTab) => props.onTabChange(value)} sx={TABS_SX}>
                {TABS.map(t => (
                    <Tab key={t} value={t} label={sidebarTabLabel(t)} disabled={t === "anchors" && props.anchorsDisabled} />
                ))}
            </Tabs>
            <Tooltip title="Hide the elevation preview">
                <IconButton size="small" onClick={props.onCollapse} sx={{color: "#fff", mr: 0.5}}>
                    <KeyboardDoubleArrowRight fontSize="small" />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
